export const mergeArrayBuffers = (firstData: ArrayBuffer, secondData: ArrayBuffer) => {
  const array = new Uint8Array(firstData.byteLength + secondData.byteLength);
  array.set(new Uint8Array(firstData), 0);
  array.set(new Uint8Array(secondData), firstData.byteLength);
  return array.buffer;
};
